// 玄関（ゲスト）で選んだ「記憶の参拝」を、ログインまでこの端末に預かる。
//   - 保存先は localStorage のみ（サーバーには何も送らない。位置も時刻も持たない）
//   - ログイン直後に flushPendingKioku(uid) で users/{uid}/visits へ流し、成功した分だけ消す
//   - 1 日の記憶の上限（Functions の MEMORY_DAILY_LIMIT=20）に合わせて 20 社まで
// 言葉の約束: 「出会い」「マッチング」「袖振り合う」は UI に出さない。
import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../../api/firebase";

export const PENDING_KEY = "kodo.kioku.pending";
export const PENDING_MAX = 20;
const MEMORY_DAY = "0000-00-00";

function storage() {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch (e) {
    return null;
  }
}

function sanitize(list) {
  if (!Array.isArray(list)) return [];
  const seen = new Set();
  const out = [];
  for (const s of list) {
    if (!s || typeof s.shrineId !== "string" || !s.shrineId || s.shrineId.length > 64) continue;
    if (seen.has(s.shrineId)) continue;
    seen.add(s.shrineId);
    out.push({
      shrineId: s.shrineId,
      name: typeof s.name === "string" ? s.name : "",
      prefecture: typeof s.prefecture === "string" ? s.prefecture : "",
      city: typeof s.city === "string" ? s.city : "",
    });
    if (out.length >= PENDING_MAX) break;
  }
  return out;
}

export function loadPending() {
  const st = storage();
  if (!st) return [];
  try {
    return sanitize(JSON.parse(st.getItem(PENDING_KEY) || "[]"));
  } catch (e) {
    return [];
  }
}

export function savePending(list) {
  const st = storage();
  const clean = sanitize(list);
  if (!st) return clean;
  try {
    if (clean.length === 0) st.removeItem(PENDING_KEY);
    else st.setItem(PENDING_KEY, JSON.stringify(clean));
  } catch (e) {
    /* 容量超過・プライベートモードなどは黙って諦める */
  }
  return clean;
}

export function clearPending() {
  savePending([]);
}

/**
 * 預かっていた社を本人の visits に記す（source=memory・日付不明）。
 * すでに記してある社は飛ばす。書けなかった社は残して次回に回す。
 * 戻り値: 記した社の数
 */
export async function flushPendingKioku(uid) {
  if (!uid) return 0;
  const list = loadPending();
  if (list.length === 0) return 0;
  const remain = [];
  let written = 0;
  for (const s of list) {
    const ref = doc(db, "users", uid, "visits", `${s.shrineId}_${MEMORY_DAY}`);
    try {
      const snap = await getDoc(ref);
      if (!snap.exists()) {
        await setDoc(ref, { shrineId: s.shrineId, day: MEMORY_DAY, source: "memory", createdAt: serverTimestamp() });
        written += 1;
      }
    } catch (e) {
      remain.push(s);
    }
  }
  savePending(remain);
  return written;
}
